module.exports = __webpack_public_path__ + "assets/img/1d.34d4b526.png";